import { render, staticRenderFns } from "./VideoLecture.vue?vue&type=template&id=d69b7da6&scoped=true&"
import script from "./VideoLecture.vue?vue&type=script&lang=js&"
export * from "./VideoLecture.vue?vue&type=script&lang=js&"
import style0 from "./VideoLecture.vue?vue&type=style&index=0&id=d69b7da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69b7da6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VListItem,VListItemAvatar,VListItemContent,VRow})
